
import request from '@/utils/request'

/**
 * 获取店铺信息
 * @returns {Promise} 返回店铺信息
 */
export function getStoreInfo() {
  return new Promise((resolve, reject) => {
    request({
      url: '/store.listMyStore',
      method: 'get'
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取用户信息
 * @returns {Promise} 返回用户信息
 */
export function getUserInfo() {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.getUserInfo',
      method: 'get'
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询设备数量
 * @returns {Promise} 返回设备数量
 */
export function queryDevCount() {
  return new Promise((resolve, reject) => {
    request({
      url: '/admin.queryDevCount',
      method: 'get'
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询应用服务数据
 * @returns {Promise} 返回应用服务数据
 */
export function queryAppServiceData() {
  return new Promise((resolve, reject) => {
    request({
      url: '/admin.queryAppServiceData',
      method: 'get'
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
/**
 * 查询管理统计数据
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function queryAdminCount(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/admin.queryAdminCount',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询店铺订单日统计
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function queryStoreOrderDayCount(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/admin.queryStoreOrderDayCount',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
export function queryHotProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product/queryHotProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取今日数据
export function getTodayData(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/index/getTodayData',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}